module.exports = __webpack_public_path__ + "media/assets/images/signpost-blue-022f7d2eea8c7d4c1d93bd4311603f8b.svg";